import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const UpdatePelanggan = ({ onCallback, row, show, close }) => {

    const [isLoading, setLoading] = useState(false);

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {
        let defaultValues = {};
        defaultValues.name = row.name;
        defaultValues.email = row.email;
        defaultValues.phone = row.phone;
        defaultValues.address = row.address;
        reset({ ...defaultValues });
    }, [isLoading, row]);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Field harus diisi'),
        phone: Yup.string().required('Field harus diisi'),
        email: Yup.string().email(),
        address: Yup.string()
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        fetch(getEndpointUrl() + `/customer/${row.id}`, {
            method: "PUT",
            body: new URLSearchParams({
                name: data.name,
                email: data.email,
                phone: data.phone,
                address: data.address,
                user_id: userLogin.id
            }),
            headers: new Headers({
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Perubahan berhasil disimpan.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                onCallback(json.results.data);

                close()
            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Update data pelanggan"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Nama pelanggan</Form.Label>
                                    <Form.Control type="text" {...register("name")} isInvalid={errors.name ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>No Handphone</Form.Label>
                                    <Form.Control type="text" {...register("phone")} isInvalid={errors.phone ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Alamat E-mail</Form.Label>
                                    <Form.Control type="text" {...register("email")} isInvalid={errors.email ? true : false} autoComplete="off" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <Form.Label>Alamat</Form.Label>
                                    <Form.Control type="text" as={'textarea'} {...register("address")} isInvalid={errors.address ? true : false} autoComplete="off" />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="primary" type="submit">Simpan perubahan</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(UpdatePelanggan);
